import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModal } from '../../actions';

import { userCan } from '../../helpers/Auth';

const FileStatus = ({
  file, share, handleChangeStatus, alwaysShowStatus,
}) => {
  const intl = useIntl();

  if (!file.status && !alwaysShowStatus) {
    return null;
  }

  const styles = {
    backgroundColor: file.status ? file.status.color : '#bbb',
  };

  const editable = share ? share.status_change : userCan('file.edit', file);

  return (
    <span className={classnames('file-status-wrapper', { 'file-status-editable': editable })}>
      {/* eslint-disable jsx-a11y/click-events-have-key-events */}
      {/* eslint-disable jsx-a11y/no-static-element-interactions */}
      <i
        className="file-status"
        style={styles}
        id={`FileStatusTooltip-${file.uuid}`}
        onClick={() => {
          if (editable) {
            handleChangeStatus([file]);
          }
        }}
      />
      {/* eslint-enable jsx-a11y/click-events-have-key-events */}
      {/* eslint-enable jsx-a11y/no-static-element-interactions */}
      <UncontrolledTooltip placement="bottom" target={`FileStatusTooltip-${file.uuid}`} fade={false}>
        {file.status ? file.status.name : intl.formatMessage({ defaultMessage: 'No status' })}
      </UncontrolledTooltip>
    </span>
  );
};

const mapStateToProps = state => ({
  share: state.Shares.share,
});

const mapDispatchToProps = dispatch => ({
  handleChangeStatus: (files) => {
    dispatch(showModal('StatusModal', {
      className: 'status-change',
      files,
      backdrop: true,
      request: true,
    }));
  },
});

FileStatus.propTypes = {
  file: PropTypes.object.isRequired,
  share: PropTypes.object,
  handleChangeStatus: PropTypes.func.isRequired,
  alwaysShowStatus: PropTypes.bool,
};

FileStatus.defaultProps = {
  share: null,
  alwaysShowStatus: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(FileStatus);
